import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

import {
  withDefaults,
  onUnmounted,
  ref,
  onUpdated,
  onMounted,
} from "vue";
import FamilyMember from "@/bll/models/FamilyMember.mjs";
import MemberNode from "./MemberNode.vue";
import TreeUtils from "@/bll/tree_utils.mjs";

interface Props {
  familyMembers: FamilyMember[];
  isAscending: boolean;
  isAscentionAllowed?: boolean;
  isDescentionAllowed?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'GenerationComponent',
  props: {
    familyMembers: {},
    isAscending: { type: Boolean },
    isAscentionAllowed: { type: Boolean, default: true },
    isDescentionAllowed: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props;

const container = ref();



onMounted(() => {
  setClassList();
  window.addEventListener("resize", calculateBarWidth);
  calculateBarWidth();
});

onUpdated(() => {
  calculateBarWidth();
});

onUnmounted(() => {
  window.removeEventListener("resize", calculateBarWidth);
});

function setClassList() {
  if (showConnectionBar()) {
    container.value.classList.add("show-generation-connection-bar");
  }
  container.value.classList.add(props.isAscending ? "ascending" : "descending");
}

function showTopVerticalBarForMember(member: FamilyMember): boolean {
  return !props.isAscending || TreeUtils.getAncestors(member).length > 0;
}

function showBottomVerticalBarForMember(member: FamilyMember) {
  return props.isAscending || TreeUtils.getDescendents(member).length > 0;
}

function calculateBarWidth() {
  // We need to wait until "self-container" left margin has been calculated
  // For some reason, if we don't "delay" the calculateBarWidth call, it calculates and sets the bar
  // width before "self-container" left is calculated, so the bar width is off by the amount set for "self-container" left margin.
  // This is a hacky way to "delay" calculateBarWidth until after "self-container" margin left has has been set.
  setTimeout(() => {
    const memberNodeContainerQuerySelector =
      ":scope.show-generation-connection-bar>li>.member-node-container";
    const immedateChildrenNodes = container.value.querySelectorAll(
      memberNodeContainerQuerySelector + ">.node-container"
    );
    const firstChild = immedateChildrenNodes[0];
    const lastChild = immedateChildrenNodes[immedateChildrenNodes.length - 1];

    if (firstChild && lastChild) {
      const verticalBarPlacementClass = props.isAscending ? ".bottom" : ".top";

      const firstVerticalBar = container.value.querySelector(
        memberNodeContainerQuerySelector +
          ">.vertical-bar" +
          verticalBarPlacementClass
      );

      const offsetLeft =
        firstVerticalBar.getBoundingClientRect().left -
        container.value.getBoundingClientRect().left;

      const width =
        lastChild.getBoundingClientRect().left -
        firstChild.getBoundingClientRect().left;

      container.value.style.setProperty("--top-bar-width", width + "px");
      container.value.style.setProperty("--top-bar-left", offsetLeft + "px");
    }
  }, 0);
}

function showConnectionBar(): boolean {
  return props.familyMembers.length > 1;
}

return (_ctx: any,_cache: any) => {
  const _component_GenerationComponent = _resolveComponent("GenerationComponent", true)!

  return (_openBlock(), _createElementBlock("ul", {
    ref_key: "container",
    ref: container,
    class: "generation-container"
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.familyMembers, (member) => {
      return (_openBlock(), _createElementBlock("li", {
        key: member.name
      }, [
        (_ctx.isAscentionAllowed && _unref(TreeUtils).getAncestors(member).length > 0)
          ? (_openBlock(), _createBlock(_component_GenerationComponent, {
              key: 0,
              "family-members": _unref(TreeUtils).getAncestors(member),
              "is-ascending": true,
              "is-descention-allowed": !_ctx.isAscending
            }, null, 8, ["family-members", "is-descention-allowed"]))
          : _createCommentVNode("", true),
        _createVNode(MemberNode, {
          member: member,
          "display-top-bar": showTopVerticalBarForMember(member),
          "display-bottom-bar": showBottomVerticalBarForMember(member)
        }, null, 8, ["member", "display-top-bar", "display-bottom-bar"]),
        (
          _ctx.isDescentionAllowed && _unref(TreeUtils).getDescendents(member).length > 0
        )
          ? (_openBlock(), _createBlock(_component_GenerationComponent, {
              key: 1,
              "family-members": _unref(TreeUtils).getDescendents(member),
              "is-ascending": false,
              "is-ascention-allowed": false
            }, null, 8, ["family-members"]))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ], 512))
}
}

})